import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
	buttons = [
		{
			description: 'Yes',
			event: 'true',
			type: 'warn',
		},
		{
			description: 'No',
			event: 'false',
			type: 'basic',
		},
	];

	dialogProperties = {
		title: 'Confirm action',
		body: 'Do you confirm the next action?',
	};

	content: string = '';

	constructor(
		public dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		if (this.data.dialogProperties) {
			this.dialogProperties = this.data.dialogProperties;
		}

		if (this.data.dialogProperties.buttons) {
			this.buttons = this.data.dialogProperties.buttons;
		}

		this.content = this.data.dialogProperties.content;
	}

	/**
	 * Emits an event with the button.
	 * @param button the button clicked.
	 */
	emitClick(button: any) {
		this.dialogRef.close(button);
	}
}
